/**
 * Created by thomas on 30/05/2017 edited on 10/2019
 *
 * SCORM VERSION 1.2 (API DOC : https://scorm.com/scorm-explained/technical-scorm/run-time/run-time-reference/#section-2)
 *
 * Cet Handler gère la connexion a la SCORM API.
 * Il contient les methodes les plus courantes à l'utilisation de SCORM
 *
 **/

/* eslint-disable no-console */

import saw from 'scorm-api-wrapper'

// let sessionTime = new Date().getTime()

const scormHandler = {
  // Initialise la connexion avec le LMS
  initLMSConnection () {
    try {
      saw.initialize()
    } catch (e) {
      console.log('erreur de connexion a l\'api scorm : ' + e)
      return false
    }
  },

  /*
   Lit l'etat du cours via la SCORM API. (Parcours courant, parcours completes).
   */
  getDatasFromLMS () {
    try {
      console.log('read datas from lms')
      console.log(saw.getScormValue('cmi.suspend_data'))
      return JSON.parse(saw.getScormValue('cmi.suspend_data'))
    } catch (e) {
      console.log('error while retrieving datas stored on LMS : ' + e)
      return false
    }
  },

  // Enregistre les datas dans le LMS
  setDatasToLMS (datas) {
    console.log('write datas to lms')
    console.log(datas)
    try {
      saw.setScormValue('cmi.suspend_data', JSON.stringify(datas))
      console.log(JSON.stringify(datas))
    } catch (e) {
      console.log('error while writing datas to LMS : ' + e)
    }
  },

  // Enregistre la progression dans le LMS
  writeProgressToLMS (progress, status) {
    console.log('write progress : ' + progress)
    console.log('write status : ' + status)
    // console.log(Number(new Date().getTime()) - Number(sessionTime))
    try {
      // Le score renvoyé a l'API doit être une string https://moodle.org/mod/forum/discuss.php?d=33032
      saw.setScormValue('cmi.core.score.raw', progress)
      saw.setScormValue('cmi.core.lesson_status', status)
      // saw.setScormValue('cmi.core.total_time', Number(new Date().getTime()) - Number(sessionTime))
    } catch (e) {
      console.log('error while sending progress and status to LMS : ' + e)
    }
  },

  commitToLMS () {
    saw.commit()
  },

  emptyLMSDatas () {
    saw.setScormValue('cmi.suspend_data', '')
  },

  getErrors () {
    return saw.sessionLogs
  },

  exitLMSConnection () {
    saw.finish()
    console.log('exit LMS connection')
    console.log('window.close')
    window.close()
  }
}

export default scormHandler
